<template>
  <section>
    <div class="container">
      <div v-if="fill_info == '' && subpage == 'open'" class="row">
        <div class="col-xs-12">
          <div class="form-title">Kitöltési útmutató</div>
          <PerfectScrollbar :options="{wheelPropagation: false, handlers:['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch']}" style="height: 50vh; border: 1px solid #f4f4f4; padding: 20px 20px 0px 20px; margin-bottom: 20px;">
          <div class="article-text medium">
            <p>Tisztelt ösztöndíjasok!</p>
            <p>Az Új Nemzeti Kiválóság Program (továbbiakban: ÚNKP) keretein belül a Pályázati Kiírásoknak megfelelően minden ösztöndíjas számára kötelező a kutatási időszaka végén a pályázatában vállalt kutatásáról <span class="highlight">Szakmai Záró Beszámolót</span> (továbbiakban: Beszámoló) és annak részeként <span class="highlight">Témavezetői Szakmai Értékelést</span> (továbbiakban: Értékelés) benyújtania a megfelelő igazolásokkal együtt.</p>
            <p>A Beszámoló és az Értékelés sablonjait a <span class="highlight">KTR</span> rendszerbe (ktr.sze.hu) belépve tudják letölteni.</p>
            <p>A Beszámolót intézményünk ÚNKP bíráló bizottsága fogja értékelni Kiváló, Megfelelt és Nem megfelelt minősítéssel.</p>
            <p>A Nem megfelelt minősítést kapott ösztöndíjasok kötelesek a korábban megkapott ösztöndíjukat a Széchenyi István Egyetemnek visszafizetni. (ld. Pályázati Kiírások).</p>
            <p>A <span class="highlight">KTR-be</span> legyenek kedvesek legkésőbb <span class="highlight">2020. február 3-án</span> <u>véglegesíteni</u> a Beszámolójukat, illetve <span class="highlight">2020. február 4-én 11-óráig</span> az Igazgatási Épület (SZE Győr) 209-es irodájában <span class="highlight">papír alapon</span> leadni az aláírt <u>Beszámolót, Értékelést, Konzultációs lapot</u> és a Beszámolóhoz tartozó összes eredeti igazolást, publikációt, mellékletet.</p>
            <p>Kitöltési segédlet:</p>
            <ul class="ordered-list with-icon" style="padding-bottom: 20px;">
              <li><i class="fa fa-angle-right"></i>A Beszámolókból legyen kedves a pályázatakor megadott kategória szerinti sablont választani.</li>
              <li><i class="fa fa-angle-right"></i>Az Értékelést – a fejlécet kitöltve – legyen kedves eljuttatni a témavezetőjéhez és azt a Beszámoló részeként kitöltve feltölteni a KTR rendszerbe.</li>
              <li><i class="fa fa-angle-right"></i>Az 1-5 pontot legyen kedves kifejteni, de a Beszámoló teljes terjedelme ne legyen több 2-3 oldalnál.</li>
              <li><i class="fa fa-angle-right"></i>A 2/a. pontnál legyen kedves nyilatkozni, hogy az ÚNKP intézményi kerete terhére történt-e költségelszámolás, mi volt az, hogyan használta fel az ÚNKP kutatás során (1mondat), ill. amennyiben releváns a beszerzésre került anyagok/eszközök Egyetemi leltárba kerültek vagy fogyóeszköznek minősültek (a nem kívánt rész törlendő – ha nem volt ezirányú beszerzése az egész mondat).</li>
              <li><i class="fa fa-angle-right"></i>A 6. pontban az intézményen belüli kötelező vállalásokról nyilatkozik, kérem, ne javítsa a sablon szövegét. Az ÚNKP Tanulmánykötet terveink szerint 2020. június 30-a előtt fog megjelenni, ill. az ÚNKP konferenciákat 2020 áprilisában szeretnénk megtartani.</li>
              <li><i class="fa fa-angle-right"></i>7. pontnál legyen kedves minden cellát kitölteni, a 0-ákat is beírva.</li>
              <li><i class="fa fa-angle-right"></i>A keltezési időpontokat legyen kedves változatlanul hagyni a Beszámolón és az Értékelésen is.</li>
            </ul>
            <p>Köszönettel és üdvözlettel,
              <br>ÚNKP felelős
            </p>
          </div>
          </PerfectScrollbar>
          <button @click="subpage = 'data'" type="button" class="button">Tovább</button>
        </div>
      </div>
      <div v-if="fill_info == '' && subpage == 'data'" class="row">
        <div class="col-xs-12">
          <div class="form-title">Adatok</div>
        </div>
        <div class="col-sm-6">
          <inputbox id="nev" label="Viselt neve <span style='font-size: 10px; display: block; font-weight: 400'>(A dr-i, egyéb nevére vonatkozó előtagokat, a neve után vesszővel elválasztva tüntesse fel)</span>" name="nev" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ,]+" v-model="form.nev" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox id="email" label="E-mail cím <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>" name="email" v-model="form.email" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox id="mobilszam" label="Mobilszám" mask="+99 99 / 999 9999" regexp_filter="[0-9]+" name="mobilszam" v-model="form.mobilszam" :errors="errors"/>
        </div>
        <div class="clearfix"></div>

        <div class="col-xs-12">
          <div class="info-box download" style="margin-bottom: 5px;">
            <a target="_blank" href="assets/files/szakmai_zaro_beszamolo_sablon_alapkepzes_tehetseggel_fel.docx" title="Szakmai záró beszámoló alapképzés sablon letöltés">
              <span class="highlight">Szakmai záró beszámoló alapképzés sablon</span> letöltés
            </a>
          </div>
          <div class="info-box download" style="margin-bottom: 5px;">
            <a target="_blank" href="assets/files/szakmai_zaro_beszamolo_sablon_mester(osztatlan)_kepzes.docx" title="Szakmai záró beszámoló mester (osztatlan) sablon letöltés">
              <span class="highlight">Szakmai záró beszámoló mester (osztatlan) sablon</span> letöltés
            </a>
          </div>
          <div class="info-box download" style="margin-bottom: 5px;">
            <a target="_blank" href="assets/files/szakmai_zaro_beszamolo_sablon_doktori_hallgato_doktorjelolt.docx" title="Szakmai záró beszámoló doktori hallgató, doktorjelölt sablon letöltés">
              <span class="highlight">Szakmai záró beszámoló doktori hallgató, doktorjelölt sablon</span> letöltés
            </a>
          </div>
          <div class="info-box download">
            <a target="_blank" href="assets/files/temavezetoi_szakmai_ertekeles_sablon.docx" title="Témavezetői szakmai értékelés sablon letöltés">
              <span class="highlight">Témavezetői szakmai értékelés sablon</span> letöltés
            </a>
          </div>
        </div>

        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.szakmai_zaro_beszamolo_szerkesztheto = value; }" accepted_files="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :errors="errors" id="szakmai_zaro_beszamolo_szerkesztheto" label="Szakmai Záró Beszámoló szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Záró Szakmai Beszámoló_szerk. legyen.)</span>" name="szakmai_zaro_beszamolo_szerkesztheto" :loaded_files="form.szakmai_zaro_beszamolo_szerkesztheto"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.szakmai_zaro_beszamolo = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="szakmai_zaro_beszamolo" label="Szakmai Záró Beszámoló aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Záró Szakmai Beszámoló legyen.)</span>" name="szakmai_zaro_beszamolo" :loaded_files="form.szakmai_zaro_beszamolo"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.temavezetoi_szakmai_ertekeles_szerkesztheto = value; }" accepted_files="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :errors="errors" id="temavezetoi_szakmai_ertekeles_szerkesztheto" label="Témavezetői Szakmai Értékelés szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Témavezetői Szakmai Értékelés_szerk. legyen.)</span>" name="temavezetoi_szakmai_ertekeles_szerkesztheto" :loaded_files="form.temavezetoi_szakmai_ertekeles_szerkesztheto"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.temavezetoi_szakmai_ertekeles = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="temavezetoi_szakmai_ertekeles" label="Témavezetői Szakmai Értékelés aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Témavezetői Szakmai Értékelés legyen.)</span>" name="temavezetoi_szakmai_ertekeles" :loaded_files="form.temavezetoi_szakmai_ertekeles"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.konzultacios_lap = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="konzultacios_lap" label="Konzultációs lap aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Konzultációs lap legyen.)</span>" name="konzultacios_lap" :loaded_files="form.konzultacios_lap"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.kutatasi_terv = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="kutatasi_terv" label="Kutatási terv aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A pályázat beadásakor (alapképzés esetén szeptemberben) leadott eredeti, aláírt Kutatási Terv), (A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Kutatási terv legyen.)</span>" name="kutatasi_terv" :loaded_files="form.kutatasi_terv"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="10" @change="(value) => { form.mellekletek = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="mellekletek" label="Mellékletek <span style='font-size: 10px; display: block; font-weight: 400'>(A melléklet elnevezése, száma a Szakmai Záró Beszámoló pontjai szerint. Doktori hallgatói-, doktorjelölt kategóriánál az MTMT lista kötelező melléklet. A 6. pont teljesítését központilag az Intézményi Szakmai Beszámolóban fogjuk igazolni.)</span>" name="mellekletek" :loaded_files="form.mellekletek"/>
        </div>

        <div class="col-xs-12">
          <div v-for="(url, i) in form.melleklet_urlek" style="display: flex; align-items: center; margin-bottom: 5px;">
            <input type="text" placeholder="Külső Url (pl.: http://webcim.hu/dokumentum.pdf)" class="form-control" v-model="form.melleklet_urlek[i]"/>
            <a :href="form.melleklet_urlek[i]" target="_blank" style="margin-left: 5px;" class="button only-icon v2">
              <i class="fa fa-eye"></i>
            </a>
            <button @click="deleteUrl(i)" style="margin-left: 5px;" type="button" class="button only-icon">
              <i class="fa fa-trash-o"></i>
            </button>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 20px;">
            <input type="text" placeholder="Külső Url (pl.: http://webcim.hu/dokumentum.pdf)" class="form-control" v-model="uj_melleklet_url">
            <button @click="addUrl" style="margin-left: 5px;" type="button" class="button only-icon v2">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>

        <div class="col-xs-12">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <button v-on:click="save(1)" :disabled="saving" type="button" class="button">Mentés</button>
            <button v-on:click="save(2)" :disabled="saving" type="button" class="button">Véglegesít</button>
          </div>
        </div>
      </div>
      <div v-if="fill_info != ''" class="row">
        <div class="col-xs-12">
          <div class="form-title">ÚNKP Szakmai Záró Beszámoló</div>
          <div v-html="fill_info"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

export default {
  components: {
    PerfectScrollbar
  },
  data: function() {
    return {
      saving: false,
      errors: [],
      fill_info: '',
      subpage: 'open',
      uj_melleklet_url: '',
      form: {
        tipus: 0,
        nev: '',
        email: '',
        mobilszam: '',
        szakmai_zaro_beszamolo_szerkesztheto: [],
        szakmai_zaro_beszamolo: [],
        temavezetoi_szakmai_ertekeles_szerkesztheto: [],
        temavezetoi_szakmai_ertekeles: [],
        konzultacios_lap: [],
        kutatasi_terv: [],
        mellekletek: [],
        melleklet_urlek: []
      }
    }
  },

  computed: {
  },

  watch: {
  },

  mounted: function() {
    var _this = this;

  	Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $(window).scrollTop(0);
      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });

    this.$root.ajax('form/unkp_beszamolo_ell/' + this.form.tipus, {
      success: function(response) {
        if (response.error != false) {
          _this.fill_info = response.error;
          return;
        }

        if (response.form != undefined) {
          _this.form = response.form;
        }
      }
    });
  },

  methods: {
    deleteUrl: function(i) {
      this.form.melleklet_urlek.splice(i, 1);
    },

    addUrl: function() {
      if (this.uj_melleklet_url != '') {
        this.form.melleklet_urlek.push(this.uj_melleklet_url);
        this.uj_melleklet_url = '';
      }
    },

    save: function(veglegesit) {
      var _this = this;

      this.saving = true;
      this.errors = [];

      if (this.uj_melleklet_url != '') {
        swal('Figyelem!', 'A melléklet url-jét "+" jellel adja hozzá a listához.', 'error');
        this.saving = false;
        return;
      }

      this.$root.ajax('form/unkp_beszamolo_ment', {
        method: 'POST',
        data: {
          form: JSON.stringify(this.form),
          veglegesit: veglegesit
        },
        success: function(response) {
          _this.saving = false;

          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = veglegesit == 1 ? 'Ön elmentette az űrlap kitöltését. Befogadáshoz Önnek véglegesítenie kell a kitöltését. Az űrlap megtekintéséhez kattintson az alábbi <a href="javascript:void(0)" onclick="location.reload()">linkre.</a>' : 'Köszönjük, Ön sikeresen véglegesítette az űrlap kitöltését.';
          }
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// unkp_beszamolo.vue?f3d38442